import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { SanityImage } from '~/components/sanity-image';
import { SanityImageType } from '~/features/page-template/models/image';

export type TransformationStatsSectionProps = {
  title: string;
  description: string;
  stats: Array<{
    _id: string;
    title: string;
    description: string;
    image: SanityImageType;
  }>;
};

export function TransformationStatsSection({ title, description, stats }: TransformationStatsSectionProps) {
  return (
    <Box
      as='section'
      backgroundColor='gray.50'
      padding={{
        base: '40px 0px',
        md: '48px 0px 80px',
      }}
    >
      <ContentContainer>
        <Flex flexDir='column' gap='8px' marginBottom='48px' textAlign='center'>
          <HeadingWithEmphasis
            text={title}
            emphasisProps={{
              fontWeight: '500',
              color: 'blue.500',
            }}
            headingProps={{
              size: 'marketing-5xl',
              as: 'h2',
            }}
          />
          <Text>{description}</Text>
        </Flex>
        <Flex
          gap='32px'
          flexDir={{
            base: 'column',
            md: 'row',
          }}
        >
          {stats.map((stat) => {
            // Note: we need to do this to split the source information from the main stat description.
            const [start = null, end = null] = stat.description.split(/\*\s?Source:/);
            return (
              <Flex
                key={stat._id}
                as='article'
                bgGradient='linear(to-b, blue.700, blue.800)'
                borderRadius='24px 8px'
                color='white'
                flex='1'
                gap='24px'
                padding='40px'
                alignItems={{
                  md: 'center',
                }}
                flexDir={{
                  base: 'column',
                  md: 'row',
                }}
              >
                <SanityImage alt='' height={80} image={stat.image} width={80} />
                <Flex flex='1' flexDir='column' gap='8px'>
                  <Heading as='p' fontWeight='500' size='marketing-5xl'>
                    {stat.title}
                  </Heading>
                  <Heading as='p' size='marketing-lg'>
                    {start}
                    {end && (
                      <Heading as='span' display='block' fontFamily='body' fontWeight='400' size='sm'>
                        &#42; Source: {end}
                      </Heading>
                    )}
                  </Heading>
                </Flex>
              </Flex>
            );
          })}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
